import axios from 'axios';
import Cookies from 'js-cookie';
import NProgress from 'nprogress';
import TENANT_API_DOMAIN from 'constants/api';
import { TOKEN } from 'constants/cookies';
import { get } from 'lodash';
import { lowerCaseKey } from 'utilities/common';
import 'nprogress/nprogress.css';
import { LOGIN } from 'routers/route-path';
import { HTTP_STATUS } from 'constants/common';

let requestsCounter = 0;
NProgress.configure({ showSpinner: false });
const instance = axios.create({
  baseURL: `${TENANT_API_DOMAIN()}/`,
});

// Set the AUTH token for any request
instance.interceptors.request.use(function (config) {
  requestsCounter++;
  NProgress.start();
  let token = Cookies.get(TOKEN);
  const language = localStorage.getItem('language') || 'en';

  config.headers.Authorization = token ? `Bearer ${token}` : '';
  config.headers['Accept-Language'] = language ? language : '';

  return config;
});

// Add a response interceptor
instance.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data

    if (--requestsCounter === 0) {
      NProgress.done();
    }
    return response;
  },
  function (error) {
    // Do something with response error
    // console.log('err', error.toJSON());

    // Object.entries(error).map(([label, value], idx) => {
    //   console.log(`idx ${idx}`, label, value);
    // });

    if (--requestsCounter === 0) {
      NProgress.done();
    }

    const { status } = error.response;

    switch (status) {
      case HTTP_STATUS.UNAUTHORIZED:
        window.location.href = `${window.location.origin}${LOGIN}`;
        break;
      case HTTP_STATUS.FORBIDDEN:
      // todo
      default:
        // other case
        break;
    }

    const resp = lowerCaseKey(
      get(error, 'response.data') || { Message: 'Error !' }
    );
    return Promise.reject(resp);
  }
);

const updateProgress = (e) =>
  NProgress.inc(calculatePercentage(e.loaded, e.total));
const calculatePercentage = (loaded, total) => Math.floor(loaded * 1.0) / total;

instance.defaults.onDownloadProgress = updateProgress;
instance.defaults.onUploadProgress = updateProgress;

export default instance;

const CancelToken = axios.CancelToken;
const isCancel = axios.isCancel;
export { CancelToken, isCancel };
